import {
  Box,
  Button,
  CardMedia,
  makeStyles,
  Typography,
} from "@material-ui/core";
import photo from "./GreenBanner.png";
import { useMediaQuery } from "@material-ui/core";

const useStyles = makeStyles(({ palette, spacing }) => ({
  greenBanner: {
    gridArea: "GreenBanner",
    backgroundColor: palette.primary.main,
    padding: `${spacing(5)}px 0`,
    display: "grid",
    gridTemplateColumns: "50% 50%",
    placeItems: "center",
  },
  greenBannerMob: {
    gridArea: "GreenBanner",
    backgroundColor: palette.primary.main,
    padding: `${spacing(5)}px 0`,
    display: "grid",
    gridTemplateColumns: "50% 50%",
    placeItems: "center",
  },
  image: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageMob: {
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  img: {
    width: "486px",
    height: "486px",
    borderRadius: "50%",
  },
  imgMob: {
    width: "356px",
    height: "356px",
    borderRadius: "50%",
    marginLeft: "50px",
  },
  text: {
    display: "flex",
    flexDirection: "column",
  },
  textMob: {
    display: "flex",
    flexDirection: "column",
    zIndex: "50",
  },
  title: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "white",
    fontWeight: 800,
    fontSize: "52px",
    lineHeight: "63px",
  },
  titleMob: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "white",
    fontWeight: 800,
    fontSize: "52px",
  },
  paragraph: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "white",
    fontWeight: 500,
    fontSize: "24px",
    lineHeight: "29px",
    display: "flex",
    alignItems: "center",
  },
  paragraphMob: {
    margin: `${spacing(2)}px 0`,
    width: "90%",
    color: "white",
    fontWeight: 500,
    fontSize: "24px",

    display: "flex",
    alignItems: "center",
  },
  btn: {
    width: "fit-content",
    borderRadius: "45px",
    backgroundColor: "white",
  },
  btnMob: {
    width: "fit-content",
    borderRadius: "45px",
    backgroundColor: "white",
  },
  containedText: {
    padding: spacing(1),
    color: palette.primary.main,
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "25px",
    textTransform: "none",
  },
  containedTextMob: {
    padding: spacing(1),
    color: palette.primary.main,
    fontWeight: 800,
    fontSize: "20px",
    lineHeight: "25px",
    textTransform: "none",
  },
  semantic: {
    color: palette.secondary.main,
  },
  semanticMob: {
    color: palette.secondary.main,
    textTransform: "uppercase",
  },
}));

const GreenBanner = (props) => {
  const mobile = useMediaQuery("(max-width:768px)");

  const classes = useStyles();

  return (
    <Box className={!mobile ? classes.greenBanner : classes.greenBannerMob}>
      <Box
        component="div"
        className={!mobile ? classes.image : classes.imageMob}
      >
        <CardMedia
          component="img"
          image={photo}
          className={!mobile ? classes.img : classes.imgMob}
        />
      </Box>
      <Box component="div" className={!mobile ? classes.text : classes.textMob}>
        <Typography
          variant="h2"
          className={!mobile ? classes.title : classes.titleMob}
        >
          Nuestro segundo nombre es{" "}
          <b className={!mobile ? classes.semantic : classes.semanticMob}>
            seguro
          </b>
        </Typography>
        <Typography
          p="true"
          className={!mobile ? classes.paragraph : classes.paragraphMob}
        >
          Blanco Seguro se asegura de cumplir con los protocolos de bioseguridad
          impuestos por la actual pandemia de COVID-19, cada viaje con Blanco
          seguro es sinónimo de seguridad
        </Typography>
        <Button
          variant="contained"
          color="inherit"
          className={!mobile ? classes.btn : classes.btnMob}
        >
          <Typography
            p="true"
            className={
              !mobile ? classes.containedText : classes.containedTextMob
            }
          >
            Descarga la app
          </Typography>
        </Button>
      </Box>
    </Box>
  );
};

export default GreenBanner;
